export const detectPfPolicyIntent = (text: string) => {
    const cleaned = text.toLowerCase().trim();

    /** ----------------------------------
     * DELETE: No name
     * ---------------------------------- */
    if (cleaned === "delete pf policy" || cleaned === "remove pf policy") {
        return { intent: "delete_pf_policy" };
    }

    /** ----------------------------------
     * DELETE: With name
     * ---------------------------------- */
    const deleteMatch = cleaned.match(/delete (.+) pf policy/);
    if (deleteMatch) {
        return { intent: "delete_pf_policy", name: deleteMatch[1].trim() };
    }

    /** ----------------------------------
     * CREATE: Without name
     * ---------------------------------- */
    if (cleaned.includes("create pf policy") || cleaned.includes("add pf policy")) {
        return { intent: "create_pf_policy" };
    }

    /** ----------------------------------
     * CREATE: With name
     * ---------------------------------- */
    const createMatch = cleaned.match(/create pf policy named (.+)/);
    if (createMatch) {
        return { intent: "create_pf_policy", name: createMatch[1].trim() };
    }

    return null;
};
